/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Training_Zones_One_LinerInputs */

const en_exp_training_zones_one_liner = /** @type {(inputs: Exp_Training_Zones_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Five intensity zones, set from your heart rate or your threshold pace.`)
};

const de_exp_training_zones_one_liner = /** @type {(inputs: Exp_Training_Zones_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fünf Zonen für deine Intensität — festgelegt über deinen Puls oder dein Schwellentempo.`)
};

/**
* | output |
* | --- |
* | "Five intensity zones, set from your heart rate or your threshold pace." |
*
* @param {Exp_Training_Zones_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_training_zones_one_liner = /** @type {((inputs?: Exp_Training_Zones_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Training_Zones_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_training_zones_one_liner(inputs)
	return de_exp_training_zones_one_liner(inputs)
});